import { SUPPLIER_NAME_COLUMN_FIELD } from './table-columns.const';

const SUPPLIER_NAME_TAG =
  '(SELECT t.value FROM UNNEST(tags) AS t WHERE t.key = "supplierName" LIMIT 1)';

export const SUPPLIER_NAME_TABLE_COLUMN = `${SUPPLIER_NAME_TAG} as ${SUPPLIER_NAME_COLUMN_FIELD}`;

export const SUPPLIER_NAME_REPORT_COLUMN = `${SUPPLIER_NAME_TAG} AS \`Supplier Name\``;
